<template>
  <ResumeNote
    class="one-response-note-card"
    :value="value"
    :author-name="authorName"
    :time="time"
    @save="saveNote"
  />
</template>

<script>
import { mapActions } from 'vuex';
import ResumeNote from '../resume-helpers/ResumeNote';

export default {
  name: 'OneResponseNoteCard',
  components: {
    ResumeNote,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    authorName: {
      type: String,
      default: '',
    },
    time: {
      type: [String, Date],
      default: '',
    },
    resumeResponse: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('vacancies/responses', [
      'saveResponseNote',
    ]),
    async saveNote({ value, callback }) {
      const { sent_resume_id } = this.resumeResponse;
      const success = await this.saveResponseNote({ note: value, sent_resume_id });

      if (success) {
        const newNote = { text: value, customer: this.$tResumePage('I'), date: this.$tResumePage('now') };
        this.$emit('update:resume-response', { note: newNote });
        callback();
      }
    },
  },
};
</script>
